import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import formatAmount from 'donor-elf-web/helpers/format-amount';

export default class EventInfoCatchupGiftComponent extends Component<EventInfoComponentArgs> {
  <template>
    <div>
      They gave
      {{formatAmount @eventModel.custom.donation_amount removeNoCents=true}}
      to help catch-up from being behind
      {{formatAmount @eventModel.custom.behind_amount removeNoCents=true}}
      in giving towards their pledge.
    </div>
  </template>
}
